import React from 'react';
import { Select } from 'antd';

import { concatOperators } from '../../constants/filter';

const { Option } = Select;

const ConcatOperatorSelector = ({ value, hidden, onSelect, style }) => (
  <Select
    className="ant-select-border-bottom"
    dropdownMatchSelectWidth
    dropdownStyle={{ width: 'auto' }}
    style={{
      width: 'auto',
      minWidth: 71,
      marginRight: '10px',
      ...(hidden && { visibility: 'hidden' }),
      ...style,
    }}
    value={value}
    onSelect={onSelect}
    getPopupContainer={(triggerNode) => triggerNode}
    virtual={false}
  >
    <Option value={concatOperators.AND}>and</Option>
    <Option value={concatOperators.OR}>or</Option>
  </Select>
);

export default ConcatOperatorSelector;
